<template>
  <div class="red-close">
    <RequestSmsWindow
      v-model:isOpen="isSmsModalOpen"
      :smsPayload="smsPayload"
      @valid-code="onValidSms"
    />
    <CommonBanner
      class="red-close__banner"
      :tagline="$t`Подпишите документы`"
      type="neutral"
    />
    <BarButton
      @click="$router.push('/bank/red/close/statement')"
      iconHead="i-bills"
      :title="$t`Заявление на выход из клуба Kaspi Red.`"
    />
    <CommonButton @click="openSmsModal" spaced>
      {{ $t`Подписать заявление` }}
    </CommonButton>
  </div>
</template>

<script>
import { closeRed, transferAndCloseRed, getDetailsOnClose } from "@/api/close";
import CommonBanner from "@/components/shared/banner/CommonBanner";
import CommonButton from "@/components/shared/button/CommonButton";
import BarButton from "@/components/shared/button/BarButton";
import RequestSmsWindow from "@/components/shared/sms/RequestSms";

export default {
  components: {
    BarButton,
    CommonButton,
    CommonBanner,
    RequestSmsWindow,
  },
  data() {
    return {
      isSmsModalOpen: false,
      smsPayload: {
        otpCodeName: "redclose",
      },
      goToBranch: false,
      balance: null
    };
  },
  async created() {
    this.$store.dispatch("bundle/fetchBundle");
    const { transfer, amount } = this.$route.query;
    if (transfer) {
      this.smsPayload.otpCodeName = "redclosetransfer";
      this.smsPayload.amount = amount;
    }
    const closeDetails = await getDetailsOnClose();
    this.balance = closeDetails?.balance;
    if (closeDetails?.balance > 0 && closeDetails?.products.length === 0){
      this.goToBranch = true;
    }
    this.$logAnalyticEvent("mybank_red_close_document_list", {
      page_path: "/bank/closered/documentforsign",
    });
  },
  methods: {
    openSmsModal() {
      this.isSmsModalOpen = true;
    },
    async onValidSms() {
      this.$logAnalyticEvent("mybank_red_close_sms_confirmation", {
        page_path: "/bank/closered/documentforsign",
      });

      const { transfer, amount, id, purpose } = this.$route.query;
      const query = {};

      if (transfer && parseFloat(amount) > 0) {
        await transferAndCloseRed(id);
        query.transfer = this.$route.query.transfer;
      } else {
        await closeRed();
        this.$logAnalyticEvent("mybank_red_close_approved", {
          page_path: "/bank/red/close",
          purpose,
        });
      }
      if (this.goToBranch){
        this.$router.push(`/bank/red/close/transfer?balance=${this.balance}`);
      } else{
        this.$router.replace({
        path: "/bank/red/close/success",
        query,
      });
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
.red-close {
  &__banner {
    margin-bottom: 1px;
  }
}
</style>
